import * as actionTypes from '../actions/actionTypes'

const initialState = {
  data: null,
  loading: false,
  message: {},
  selectedRecord: null,
  saved: false,
  structures: [],
  kpiTypes: [],
  parentKpis: [],
  uoms: [],
  perspectives: [],
  valueTypes: [],
  functionTypes: [],
  competencyTypes: [],
  companies: [],
  tags: [],
  kpis: [],
  filterCompanies: [],
  imported: false,
  modalLoading: false,
  selectedRecordLoading: false
}

const createAppraisalItemStart = (state, action) => {
  return { ...state, modalLoading: true, saved: false }
}

const createAppraisalItemSuccess = (state, action) => {
  return {
    ...state,
    modalLoading: false,
    message: action.message,
    saved: true
  }
}

const createAppraisalItemFailed = (state, action) => {
  return {
    ...state,
    modalLoading: false,
    message: action.errorMessage,
    saved: false
  }
}

const updateAppraisalItemStart = (state, action) => {
  return { ...state, modalLoading: true, saved: false }
}

const updateAppraisalItemSuccess = (state, action) => {
  return {
    ...state,
    modalLoading: false,
    saved: true,
    message: action.message
  }
}

const updateAppraisalItemFailed = (state, action) => {
  return {
    ...state,
    modalLoading: false,
    message: action.errorMessage,
    saved: false
  }
}

const deleteAppraisalItemStart = (state, action) => {
  return { ...state, modalLoading: true, loading: true }
}

const deleteAppraisalItemSuccess = (state, action) => {
  return {
    ...state,
    modalLoading: false,
    saved: true,
    message: action.message
  }
}

const deleteAppraisalItemFailed = (state, action) => {
  return {
    ...state,
    modalLoading: false,
    saved: false,
    message: action.errorMessage
  }
}

const fetchAppraisalItemsStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const fetchAppraisalItemsSuccess = (state, action) => {
  const updatedStructure = action?.data?.structures?.map(structure => {
    return {
      ...structure,
      items: structure?.items?.map(item => {
        return {
          ...item,
          competency_name: item?.competency_type?.value_list_name,
          perspective_name: item?.perspective?.perspective_name
        }
      })
    }
  })
  return {
    ...state,
    loading: false,
    data: {
      ...action.data,
      structures: updatedStructure
    }
  }
}

const fetchAppraisalItemByIdStart = (state, action) => {
  return {
    ...state,
    selectedRecordLoading: true
  }
}

const fetchAppraisalItemByIdSuccess = (state, action) => {
  return {
    ...state,
    selectedRecordLoading: false,
    loading: false,
    selectedRecord: action.recordData
  }
}

const fetchAppraisalItemsFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecordLoading: false,
    message: action.errorMessage
  }
}

const clearSelectedStructureRecord = (state, action) => {
  return {
    ...state,
    records: [],
    pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
    selectedAppraisalStructure: null,
    saved: false
  }
}

const clearSelectedItemRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: null
  }
}

const fetchOptionsStart = (state, action) => {
  return { ...state, modalLoading: true }
}

const fetchAppraisalStructureOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    structures: action.data
  }
}

const fetchAppraisalStructureOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchKPITypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    kpiTypes: action.data
  }
}

const fetchKPITypeOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchAppraisalItemOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    kpis: action.data
  }
}

const fetchAppraisalItemOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchParentKPIOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    parentKpis: action.data.filter(item => {
      return item.item_id !== (state.selectedRecord ? state.selectedRecord.item_id : '')
    })
  }
}

const fetchParentKPIOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchUOMOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    uoms: action.data
  }
}

const fetchUOMOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchPerspectiveOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    perspectives: action.data
  }
}

const fetchPerspectiveOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchValueTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    valueTypes: action.data
  }
}

const fetchValueTypeOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchFunctionTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    functionTypes: action.data
  }
}

const fetchFunctionTypeOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchCompetencyTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    competencyTypes: action.data
  }
}

const fetchCompetencyTypeOptionsFailed = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    message: action.errorMessage
  }
}

const fetchCompanyOptionsSuccess = (state, action) => {
  return {
    ...state,
    // loading: false,
    modalLoading: false,
    companies: action.data
  }
}

const fetchCompanyOptionsFailed = (state, action) => {
  return {
    ...state,
    modalLoading: false,
    message: action.errorMessage
  }
}

const importAppraisalItemStart = (state, action) => {
  return {
    ...state,
    importLoading: true,
    imported: false
  }
}

const importAppraisalItemSuccess = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: true
  }
}

const importAppraisalItemFailed = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: false
  }
}

const exportAppraisalItemsStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const exportAppraisalItemsSuccess = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const exportAppraisalItemsFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const downloadAppraisalItemTemplateStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const downloadAppraisalItemTemplateSuccess = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const downloadAppraisalItemTemplateFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const fetchAppraisalItemTagsStart = (state, action) => {
  return {
    ...state,
    modalLoading: true
  }
}

const fetchAppraisalItemTagsSuccess = (state, action) => {
  return {
    ...state,
    modalLoading: false,
    tags: action.data
  }
}

const fetchAppraisalItemTagsFailed = (state, action) => {
  return {
    ...state,
    modalLoading: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_APPRAISAL_ITEMS_START:
      return fetchAppraisalItemsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEMS_SUCCESS:
      return fetchAppraisalItemsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEM_BY_ID_START:
      return fetchAppraisalItemByIdStart(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEM_BY_ID_SUCCESS:
      return fetchAppraisalItemByIdSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEMS_FAILED:
      return fetchAppraisalItemsFailed(state, action)
    case actionTypes.CLEAR_SELECTED_APPRAISAL_ITEM_RECORD:
      return clearSelectedItemRecord(state, action)
    case actionTypes.CLEAR_SELECTED_STRUCTURE_RECORD:
      return clearSelectedStructureRecord(state, action)
    case actionTypes.FETCH_APPRAISAL_STRUCTURE_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_STRUCTURE_OPTIONS_SUCCESS:
      return fetchAppraisalStructureOptionsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_STRUCTURE_OPTIONS_FAILED:
      return fetchAppraisalStructureOptionsFailed(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEM_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEM_OPTIONS_SUCCESS:
      return fetchAppraisalItemOptionsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEM_OPTIONS_FAILED:
      return fetchAppraisalItemOptionsFailed(state, action)
    case actionTypes.FETCH_KPI_TYPE_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_KPI_TYPE_OPTIONS_SUCCESS:
      return fetchKPITypeOptionsSuccess(state, action)
    case actionTypes.FETCH_KPI_TYPE_OPTIONS_FAILED:
      return fetchKPITypeOptionsFailed(state, action)
    case actionTypes.FETCH_PARENT_KPI_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_PARENT_KPI_OPTIONS_SUCCESS:
      return fetchParentKPIOptionsSuccess(state, action)
    case actionTypes.FETCH_PARENT_KPI_OPTIONS_FAILED:
      return fetchParentKPIOptionsFailed(state, action)
    case actionTypes.FETCH_UOM_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_UOM_OPTIONS_SUCCESS:
      return fetchUOMOptionsSuccess(state, action)
    case actionTypes.FETCH_UOM_OPTIONS_FAILED:
      return fetchUOMOptionsFailed(state, action)
    case actionTypes.FETCH_PERSPECTIVE_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_PERSPECTIVE_OPTIONS_SUCCESS:
      return fetchPerspectiveOptionsSuccess(state, action)
    case actionTypes.FETCH_PERSPECTIVE_OPTIONS_FAILED:
      return fetchPerspectiveOptionsFailed(state, action)
    case actionTypes.FETCH_VALUE_TYPE_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_VALUE_TYPE_OPTIONS_SUCCESS:
      return fetchValueTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_VALUE_TYPE_OPTIONS_FAILED:
      return fetchValueTypeOptionsFailed(state, action)
    case actionTypes.FETCH_FUNCTION_TYPE_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_FUNCTION_TYPE_OPTIONS_SUCCESS:
      return fetchFunctionTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_FUNCTION_TYPE_OPTIONS_FAILED:
      return fetchFunctionTypeOptionsFailed(state, action)
    case actionTypes.FETCH_COMPETENCY_TYPE_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_COMPETENCY_TYPE_OPTIONS_SUCCESS:
      return fetchCompetencyTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_COMPETENCY_TYPE_OPTIONS_FAILED:
      return fetchCompetencyTypeOptionsFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchOptionsStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanyOptionsSuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyOptionsFailed(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEM_TAGS_START:
      return fetchAppraisalItemTagsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEM_TAGS_SUCCESS:
      return fetchAppraisalItemTagsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_ITEM_TAGS_FAILED:
      return fetchAppraisalItemTagsFailed(state, action)
    case actionTypes.CREATE_APPRAISAL_ITEM_START:
      return createAppraisalItemStart(state, action)
    case actionTypes.CREATE_APPRAISAL_ITEM_SUCCESS:
      return createAppraisalItemSuccess(state, action)
    case actionTypes.CREATE_APPRAISAL_ITEM_FAILED:
      return createAppraisalItemFailed(state, action)
    case actionTypes.UPDATE_APPRAISAL_ITEM_START:
      return updateAppraisalItemStart(state, action)
    case actionTypes.UPDATE_APPRAISAL_ITEM_SUCCESS:
      return updateAppraisalItemSuccess(state, action)
    case actionTypes.UPDATE_APPRAISAL_ITEM_FAILED:
      return updateAppraisalItemFailed(state, action)
    case actionTypes.DELETE_APPRAISAL_ITEM_START:
      return deleteAppraisalItemStart(state, action)
    case actionTypes.DELETE_APPRAISAL_ITEM_SUCCESS:
      return deleteAppraisalItemSuccess(state, action)
    case actionTypes.DELETE_APPRAISAL_ITEM_FAILED:
      return deleteAppraisalItemFailed(state, action)
    case actionTypes.IMPORT_APPRAISAL_ITEMS_START:
      return importAppraisalItemStart(state, action)
    case actionTypes.IMPORT_APPRAISAL_ITEMS_SUCCESS:
      return importAppraisalItemSuccess(state, action)
    case actionTypes.IMPORT_APPRAISAL_ITEMS_FAILED:
      return importAppraisalItemFailed(state, action)
    case actionTypes.EXPORT_APPRAISAL_ITEMS_START:
      return exportAppraisalItemsStart(state, action)
    case actionTypes.EXPORT_APPRAISAL_ITEMS_SUCCESS:
      return exportAppraisalItemsSuccess(state, action)
    case actionTypes.EXPORT_APPRAISAL_ITEMS_FAILED:
      return exportAppraisalItemsFailed(state, action)
    case actionTypes.DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_START:
      return downloadAppraisalItemTemplateStart(state, action)
    case actionTypes.DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_SUCCESS:
      return downloadAppraisalItemTemplateSuccess(state, action)
    case actionTypes.DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_FAILED:
      return downloadAppraisalItemTemplateFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
